import { render, staticRenderFns } from "./FormElementFlag.vue?vue&type=template&id=0139a6c2"
import script from "./FormElementFlag.vue?vue&type=script&lang=js"
export * from "./FormElementFlag.vue?vue&type=script&lang=js"
import style0 from "./FormElementFlag.vue?vue&type=style&index=0&id=0139a6c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports